import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import CandidatePropType from "~/prop-types/candidate";
import MatchList from "~/components/MatchList";
import MatchActions from "./MatchActions";

export default class CandidateMatchList extends React.PureComponent {
    static propTypes = {
        matches: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                score: PropTypes.number.isRequired,
                candidate: CandidatePropType.isRequired,
                details: PropTypes.object.isRequired,
                explanations: PropTypes.array,
            })
        ).isRequired,
        extraColumns: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                property: PropTypes.string.isRequired,
            })
        ),
        selection: PropTypes.object,
        fixedSelection: PropTypes.object,
        noResultsLabel: PropTypes.string.isRequired,
        allowSelection: PropTypes.bool.isRequired,
        wasSearched: PropTypes.bool.isRequired,
        isGreenMatch: PropTypes.func.isRequired,
        className: PropTypes.string,
        onView: PropTypes.func.isRequired,
        onMatch: PropTypes.func,
        onSelectionChange: PropTypes.func,
    };

    static defaultProps = {
        allowSelection: false,
        wasSearched: false,
        fixedSelection: {},
    };

    constructor(props) {
        super(props);

        this.mainRef = React.createRef();
    }

    scrollToTop() {
        this.mainRef.current.scrollToTop();
    }

    render() {
        const {
            className,
            matches,
            allowSelection,
            wasSearched,
            selection,
            fixedSelection,
            extraColumns,
            noResultsLabel,
            isGreenMatch,
            onView,
            onSelectionChange,
        } = this.props;

        return (
            <MatchList
                ref={this.mainRef}
                className={className}
                matches={matches}
                allowSelection={allowSelection}
                wasSearched={wasSearched}
                selection={selection}
                fixedSelection={fixedSelection}
                extraColumns={extraColumns}
                noResultsLabel={noResultsLabel}
                renderDetailsColumnHeader={renderDetailsColumnHeader}
                renderDetailsColumn={renderDetailsColumn}
                renderMatchActions={this.renderMatchActions}
                extraColumnPropertyRoot={extraColumnPropertyRoot}
                isGreenMatch={isGreenMatch}
                onView={onView}
                onSelectionChange={onSelectionChange}
            />
        );
    }

    renderMatchActions = match => {
        const {onMatch} = this.props;

        if (!onMatch) {
            return null;
        }

        return <MatchActions match={match} onMatch={onMatch} />;
    };
}

function renderDetailsColumnHeader() {
    return <FormattedMessage id="column.jobFunction" />;
}

function renderDetailsColumn(match) {
    return getJobFunctionLabel(match);
}

export function getJobFunctionLabel(match) {
    const jobFunctions = match.candidate.matchProfile.aspects.jobFunctions;

    if (jobFunctions === undefined) {
        return "—";
    }

    const jobFunction = jobFunctions.value[0];

    if (jobFunction === undefined || jobFunction.label === undefined) {
        return "—";
    }

    return jobFunction.label;
}

function extraColumnPropertyRoot(match) {
    return match.candidate;
}
